"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Searchinitial = function Searchinitial(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "SearchinitialTitle SearchinitialDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "SearchinitialTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "SearchinitialDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.3333333333333333 0.3333333333333333)",
    d: "M34 60C19.088 60 7 47.912 7 33S19.088 6 34 6s27 12.088 27 27-12.088 27-27 27zm0-2.998c13.256 0 24.002-10.746 24.002-24.002C58.002 19.744 47.256 8.998 34 8.998 20.744 8.998 9.998 19.744 9.998 33c0 13.256 10.746 24.002 24.002 24.002z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.3333333333333333 0.3333333333333333)",
    d: "M50.797 52.515c-.558-.562-.155-1.426.63-2.204.785-.779 1.652-1.175 2.21-.613L67.12 63.292a2 2 0 1 1-2.84 2.817L50.797 52.515zM28.979 26.5A1.49 1.49 0 0 1 27.5 25c0-.826.66-1.5 1.479-1.5H45.02c.82 0 1.479.674 1.479 1.5s-.66 1.5-1.479 1.5H28.98zM23.5 35a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-16a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm5.479 7.5A1.49 1.49 0 0 1 27.5 33c0-.826.66-1.5 1.479-1.5H45.02c.82 0 1.479.674 1.479 1.5s-.66 1.5-1.479 1.5H28.98zm0 8A1.49 1.49 0 0 1 27.5 41c0-.826.66-1.5 1.479-1.5H45.02c.82 0 1.479.674 1.479 1.5s-.66 1.5-1.479 1.5H28.98z"
  }));
};

Searchinitial.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Searchinitial.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Searchinitial;
exports["default"] = _default;